import React, { useEffect } from "react";

const DemoRequest = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="breadcrumb-area order">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-12">
              <div className="breadcrumb-content">
                <h3>Discover how we can transform your business</h3>
                <p>
                  Whether you want consultancy or a live demo by a solution
                  expert, we’re here to help you explore and evaluate the ISP
                  Digital Software.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="request-order-area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="account-box">
                <div className="account-form">
                  <form action="#">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Full name *</label>
                          <input
                            type="text"
                            name="Name"
                            placeholder="ex: Jhon Doe"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>ISP Name *</label>
                          <input
                            type="text"
                            name="Name"
                            placeholder="Business name here"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Email Address *</label>
                          <input
                            type="Email"
                            name="Email"
                            placeholder="ex: yourmail@mail.com"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Business Website</label>
                          <input
                            type="text"
                            name="website"
                            placeholder="https://"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Phone Number *</label>
                          <input
                            type="text"
                            name="number"
                            placeholder="+880"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Number of user*</label>
                          <input
                            type="text"
                            name="number"
                            placeholder="ex: Your home user "
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Skype/WhatsApp ID</label>
                          <input
                            type="text"
                            name="Address"
                            placeholder="skype_id"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Office Address *</label>
                          <input
                            type="text"
                            name="Address"
                            placeholder="Address here"
                            required
                          />
                        </div>
                      </div>
                      {/* <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Country *</label>
                          <select>
                            <option value="1">USA</option>
                            <option value="2" selected="selected">
                              Bangladesh
                            </option>
                            <option value="3">Australia</option>
                          </select>
                        </div>
                      </div> */}

                      <div className="col-lg-6 offset-lg-6 col-12">
                        <div className="agree-content">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label
                            class="form-check-label"
                            for="flexCheckDefault"
                          >
                            <p>
                              I have read and agree to the{" "}
                              <a href="terms-condition.html">
                                Terms & Condition
                              </a>{" "}
                              and{" "}
                              <a href="privacy-policy.html">Privacy Policy</a>
                            </p>
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-6 offset-lg-6 col-md-6 col-12">
                        <div className="account-button">
                          <button type="submit" className="theme-btn primary">
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DemoRequest;
